import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";

function formatDate(d) {
  return new Date(d + "T12:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
}

export default function News() {
  const [news, setNews] = useState([]);
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(() => {});
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {});
  }, []);

  const artistName = (id) => artists.find((a) => a.id === id)?.name || "Joy Messenger";

  return (
    <main data-testid="news-page" className="pt-28 sm:pt-36">
      <div className="jm-container pb-24 sm:pb-32">
        <Reveal>
          <p className="jm-overline mb-5">Le journal</p>
        </Reveal>

        <div className="mt-16 border-t border-jm-brass/10" data-testid="news-list">
          {news.map((n, i) => (
            <Reveal key={n.id} delay={0.04 * i}>
              <article className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-10 py-10 border-b border-jm-brass/10" data-testid={`news-item-${n.id}`}>
                <div className="lg:col-span-3">
                  <p className="font-mono text-xs tracking-[0.18em] text-jm-brass">{formatDate(n.date)}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-jm-mute mt-2">{artistName(n.artist)}</p>
                </div>
                <div className="lg:col-span-9">
                  <h2 className="font-serif text-2xl sm:text-3xl text-jm-bone leading-snug group-hover:text-jm-brass transition-colors duration-300 max-w-3xl">
                    {n.title}
                  </h2>
                  <p className="mt-4 text-jm-smoke leading-relaxed max-w-2xl">{n.excerpt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
